import { Chat } from '@tunasong/plugin-chat/ui'
import type { SidebarComponent } from '@tunasong/ui-lib'
import type { FC } from 'react'

export const SidebarChat: FC<SidebarComponent> = ({ entity }) => <Chat element={entity} showTabs={false} />
